module.exports = __webpack_public_path__ + "img/connect-01.996a5779.jpg";